var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._b({staticClass:"upload-state",class:'state-' + _vm.defaultVal,on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},'span',_vm.$attrs,false),[_vm._v(_vm._s(_vm.stateLabel[_vm.defaultVal] || ''))])
}
var staticRenderFns = []

export { render, staticRenderFns }